import PropTypes from "prop-types";
import { Link } from "@mui/material"
import supportApi from "api/supportApi";
import { useDownload } from "./hooks";

const SampleDownload = (props) => {
  const {
    fileName,
    title,
    extension,
    api,
    methodName
  } = props;

  const downloadFileName = `${fileName}.${extension}`;

  const [handleDownload, isDownloading] = useDownload(
    api,
    methodName,
    downloadFileName
  );

  return (
    <Link
      onClick={() => handleDownload(downloadFileName)}
      style={{cursor: "pointer"}}
    >{title}</Link>
  );
};

SampleDownload.propTypes = {
  fileName: PropTypes.string.isRequired,
  title: PropTypes.string,
  extension: PropTypes.string,
  api: PropTypes.object,
  methodName: PropTypes.string
};

SampleDownload.defaultProps = {
  title: "Download Sample File",
  extension: "xlsx",
  api: supportApi,
  methodName: "downloadSampleFile"
};

export default SampleDownload;
